export default "__VITE_ASSET__4mZvUWS6__"